module.exports = __webpack_public_path__ + "static/media/img_5.41bb0f4d.png";